var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrag = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 22 22",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m4 8-3 3m0 0 3 3m-3-3h20M8 4l3-3m0 0 3 3m-3-3v20m3-3-3 3m0 0-3-3M18 8l3 3m0 0-3 3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag.07cbcb30d5b4a405abfbeda6dbba3021.svg";